import { createAction, props } from '@ngrx/store';
import { IFamilyTree } from './family-tree.model';

export enum ActionTypes {
  GET_FAMILY_TREE_REQUEST = '[GET_FAMILY_TREE] Request',
  GET_FAMILY_TREE_SUCCESS = '[GET_FAMILY_TREE] Success',
  GET_FAMILY_TREE_FAILURE = '[GET_FAMILY_TREE] Failure',

  DELETE_FAMILY_TREE_REQUEST = '[DELETE_FAMILY_TREE] Request',
  DELETE_FAMILY_TREE_SUCCESS = '[DELETE_FAMILY_TREE] Success',
  DELETE_FAMILY_TREE_FAILURE = '[DELETE_FAMILY_TREE] Failure',
}

export const getFamilyTreeRequest = createAction(ActionTypes.GET_FAMILY_TREE_REQUEST, props<{ loader?: boolean }>());

export const getFamilyTreeSuccess = createAction(ActionTypes.GET_FAMILY_TREE_SUCCESS, props<{ payload: IFamilyTree[] }>());

export const getFamilyTreeFailure = createAction(ActionTypes.GET_FAMILY_TREE_FAILURE, props<{ error: string }>());

export const deleteFamilyTreeRequest = createAction(ActionTypes.DELETE_FAMILY_TREE_REQUEST, props<{ familyTreeId: string }>());

export const deleteFamilyTreeSuccess = createAction(ActionTypes.DELETE_FAMILY_TREE_SUCCESS, props<{ familyTreeId: string }>());

export const deleteFamilyTreeFailure = createAction(ActionTypes.DELETE_FAMILY_TREE_FAILURE, props<{ error: string }>());

export type Actions =
  | ReturnType<typeof getFamilyTreeRequest>
  | ReturnType<typeof getFamilyTreeSuccess>
  | ReturnType<typeof getFamilyTreeFailure>
  | ReturnType<typeof deleteFamilyTreeRequest>
  | ReturnType<typeof deleteFamilyTreeSuccess>
  | ReturnType<typeof deleteFamilyTreeFailure>;
